import AppRoutes from "./routes/AppRoutes";
import { CompanyProvider } from "./context/CompanyContext";
import CompanyInitializer from "./components/CompanyInitializer";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <div className="font-vazir">
      <CompanyProvider>
        <CompanyInitializer />
        <Toaster position="top-right" reverseOrder={false} />
        <AppRoutes />
      </CompanyProvider>
    </div>
  );
};

export default App;
